import React, { Component } from "react";
import { SView, SText, STheme, SIcon } from "servisofts-component";
import audioerror from "../../../Assets/sonido/error.mp3"
import SSocket from 'servisofts-socket';
import Model from "../../../Model";

class AudioPlayer extends Component {
    constructor(props) {
        super(props);

        // this.audio = new Audio(props.src);
        this.audio = new Audio(audioerror);
        this.key_sucursal = props.key_sucursal;
        this.barWidth = 0;
        this.alreadyLoaded = false;


        this.state = {
            isPlaying: false,
            progress: 0,
            currentTime: 0,
            duration: 0,
        };
    }

    componentDidMount() {
        // Metadata cargada
        this.audio.addEventListener("loadedmetadata", () => {
            if (this.audio.duration && !isNaN(this.audio.duration)) {
                this.setState({ duration: this.audio.duration });
            }
        });

        // Actualizar tiempo
        this.audio.addEventListener("timeupdate", () => {
            const { currentTime, duration } = this.audio;
            if (duration && !isNaN(duration)) {
                this.setState({
                    currentTime,
                    progress: (currentTime / duration) * 100 || 0,
                });
            }
        });

        this.audio.addEventListener("ended", () => {
            this.setState({ isPlaying: false });
        });
    }

    componentWillUnmount() {
        this.audio.pause();
        this.audio.src = "";
    }

    togglePlay = () => {
        const { isPlaying } = this.state;

        if (isPlaying) {
            // PAUSA normal
            this.audio.pause();
            this.setState({ isPlaying: false });
            return;
        }

        // PLAY
        // if (!this.alreadyLoaded) {
        if (this.key_sucursal != this.props.key_sucursal) {
            this.key_sucursal = this.props.key_sucursal;

            // Primera reproducción → pedir al servidor
            SSocket.sendPromise({
                component: "audio",
                type: "reproducir_sucursal",
                key_usuario: Model.usuario.Action.getKey(),
                key_sucursal: this.props.key_sucursal,
            }).then((resp) => {
                const url = SSocket.api.root + "audio/" + resp.data?.key + ".mp3";

                // Cargar audio sin destruir el currentTime
                this.audio.src = url;
                this.audio.load();

                this.alreadyLoaded = true;
                this.audio.play();
                this.setState({ isPlaying: true });
            }).catch((e) => {
                // Error → reproducir audio local
                this.audio.src = audioerror;
                this.audio.load();

                this.alreadyLoaded = true;
                this.audio.play();
                this.setState({ isPlaying: true });
            });

        } else {
            // YA cargado previamente → continuar desde donde quedó
            this.audio.play();
            this.setState({ isPlaying: true });
        }
    };

    // togglePlay = () => {
    //     const { isPlaying } = this.state;
    //     if (isPlaying) {
    //         this.audio.pause();
    //     } else {

    //         console.log("AUDIO play")
    //         console.log("AUDIO keysucural", this.props.key_sucursal)
    //         SSocket.sendPromise({
    //             component: "audio",
    //             type: "reproducir_sucursal",
    //             // estado: "cargando",
    //             key_usuario: Model.usuario.Action.getKey(),
    //             key_sucursal: this.props.key_sucursal
    //         }).then((resp) => {
    //             const url = SSocket.api.root + "audio/" + resp.data?.key + ".mp3";

    //             this.audio = new Audio(url);
    //             this.componentDidMount();
    //             this.audio.play();
    //         }).catch(e => {
    //             this.audio = new Audio(audioerror);
    //             this.componentDidMount();
    //             this.audio.play();

    //         })

    //     }
    //     this.setState({ isPlaying: !isPlaying });
    // };




    formatTime = (sec) => {
        if (isNaN(sec)) return "00:00";
        const m = Math.floor(sec / 60);
        const s = Math.floor(sec % 60);
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };

    render() {
        const { isPlaying, progress, currentTime, duration } = this.state;

        return (
            <SView col={"xs-9"}
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    padding: 8,
                    borderRadius: 12,
                    backgroundColor: "#000",
                    gap: 8,
                }}
            >
                {/* Botón Play */}
                <SView center
                    onPress={this.togglePlay}
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: 20,
                        backgroundColor: "#E30613",
                        // backgroundColor: STheme.color.p,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {isPlaying ? <SIcon name='pauseicon' height={20} width={20} fill={STheme.color.white} /> : <SIcon name='playicon' height={20} width={20} fill={STheme.color.white} />}
                </SView>

                {/* Retroceder */}
                {/* <SView onPress={this.backward} style={{ padding: 4 }}>
                    <SText style={{ fontSize: 20 }}>{"<<"}</SText>
                </SView> */}

                {/* Adelantar */}
                {/* <SView onPress={this.forward} style={{ padding: 4 }}>
                    <SText style={{ fontSize: 20 }}>{">>"}</SText>
                </SView> */}

                {/* Barra de progreso */}
                <SView style={{ flex: 1 }}>
                    <SView
                        onLayout={(evt) => {
                            const w = evt.nativeEvent.layout.width;
                            if (w && !isNaN(w)) this.barWidth = w;
                        }}
                        style={{
                            width: "100%",
                            height: 6,
                            backgroundColor: "#ccc",
                            borderRadius: 5,
                            position: "relative",
                            cursor: "pointer",
                        }}
                    >
                        <SView
                            style={{
                                width: `${progress}%`,
                                height: "100%",
                                backgroundColor: "#25D366",
                                borderRadius: 5,
                            }}
                        />
                    </SView>

                    {/* Tiempos */}
                    <SView
                        style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: 4,
                        }}
                    >
                        <SText>{this.formatTime(currentTime)}</SText>
                        <SText>{this.formatTime(duration)}</SText>
                    </SView>
                </SView>
            </SView>
        );
    }
}

export default AudioPlayer;
